import React from 'react';

const UnauthorizedPage = () => {
    return <div className="m-3">
        <h1>Connexion denied</h1>
        <p>Please return <a href="https://optimalflowdesign.com/">home</a> to login and try again.</p>
    </div>
};

export default UnauthorizedPage;